import { render, staticRenderFns } from "./Global.vue?vue&type=template&id=74040f1a&"
import script from "./Global.vue?vue&type=script&lang=js&"
export * from "./Global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74040f1a')) {
      api.createRecord('74040f1a', component.options)
    } else {
      api.reload('74040f1a', component.options)
    }
    module.hot.accept("./Global.vue?vue&type=template&id=74040f1a&", function () {
      api.rerender('74040f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Global.vue"
export default component.exports